<div class="adtabcontent">
<div class="adtabtitle">
    <app-column-header [headerData]="headerData"></app-column-header>
   
    <!-- <div class="columnHeader"> -->
        <div class="spriteBtns">
         
            <button type="button" class="back09" title="Page Workflow" (click)="setPageWorkflow()">
                <svg class="icon">
                    <use xlink:href="assets/img/common-sprite.svg#settings"></use>
                </svg>
            </button>
            <button type="button" class="back09" title="Audit Trail" (click)="loadAuditTrial()">
                <svg class="icon">
                    <use xlink:href="assets/img/common-sprite.svg#auditTrail"></use>
                </svg>
            </button>
            <button type="button" class="back11" title="Back" (click)="backButtonClick()">
                <svg class="icon">
                    <use xlink:href="assets/img/common-sprite.svg#previous"></use>
                </svg>
            </button>
        </div>
    </div>
    <!-- </div> -->
    <form [formGroup]="form">
        <app-admin-topbutton-layout [form]="form" (updateLayout)="ngOnInit()"></app-admin-topbutton-layout>
        <app-admin-layout [form]="form" [layoutInfo]="commonLayoutArray" (updateLayout)="ngOnInit()"></app-admin-layout>
    </form>

    <form [formGroup]="layoutForm">
        <div class="addRow">
            <select class="form-control" formControlName="layout">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">Top Buttons Layout</option>
            </select>
            <button type="submit" class="commonBtn blueBtn" (click)="addLayoutRow()">{{buttonLabel.add_row}}</button>
        </div>
    </form>
</div>